import { Skeleton, TableRow, TableCell } from '@mui/material';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  columnWidths?: (number | string)[];
}

export function TableSkeleton({
  rows = 5,
  columns = 8,
  columnWidths,
}: TableSkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <TableRow key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <TableCell key={colIndex}>
              <Skeleton
                variant="text"
                width={columnWidths?.[colIndex] || '80%'}
                animation="wave"
                sx={{ bgcolor: '#F4F4F4' }}
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}

export default TableSkeleton;
